<template>
  <div class="trophy-container" @click="$emit('click')">
    <svg
      id="Ebene_1"
      :class="unlocked ? 'unlocked' : 'locked'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="25.11px"
      height="25.157px"
      viewBox="0 0 25.11 25.157"
      enable-background="new 0 0 25.11 25.157"
      xml:space="preserve"
    >
      <g>
        <path
          :fill="color"
          d="M12.539,10.812c1.473-0.075,2.416,1.886,1.408,2.975c-0.877,1.158-2.954,0.667-3.173-0.784
      C10.525,11.919,11.417,10.782,12.539,10.812 M12.539,8.654c-2.059-0.08-3.489,1.641-5.334,2.228
      c-0.353,1.162-0.966,2.98,0.717,3.077c1.4,1.06,2.325,2.629,2.863,4.272c1.132,0.273,3.129,0.723,3.691-0.508
      c0.543-1.626,1.631-3.096,3.047-4.055c0.699-0.408,0.222-2.289-0.254-2.845C15.612,10.231,14.456,8.531,12.539,8.654 M12.468,2.728
      c3.217-0.032,6.258,1.835,8.116,4.386c0.504,0.998,1.614,2.409,0.717,3.468c-0.675,0.844-2.83-0.445-2.111,1.047
      C19.58,12.497,18.75,14,20.12,13.911c1.199,0.435,1.718,1.906,1.164,3.027c-0.879,1.909-2.401,3.645-4.39,4.423
      c-1.021,0.439-2.244-0.264-2.349-1.383c-0.388-0.638-1.903,0.264-2.755-0.101c-0.818-0.191-1.392-0.367-1.442,0.659
      c-0.437,1.134-1.916,1.127-2.801,0.555C5.78,20.076,4.29,18.431,3.65,16.479c-0.371-1.197,0.528-2.464,1.706-2.728
      c-0.227-0.924,0.352-2.391,0.11-2.889c-1.084,0.375-2.529-0.487-1.935-1.734c0.894-2.854,3.446-4.899,6.165-5.924
      C10.586,2.896,11.526,2.729,12.468,2.728 M12.539,0.001C7.656-0.066,2.941,3.04,1.043,7.534
      c-2.024,4.514-1.039,10.165,2.413,13.712c3.25,3.518,8.6,4.832,13.113,3.245c4.786-1.565,8.329-6.244,8.518-11.278
      c0.313-4.84-2.489-9.678-6.827-11.837C16.498,0.471,14.52-0.002,12.539,0.001z"
        />
      </g>
    </svg>
    <p v-if="title" class="title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "Trophy",
  props: {
    unlocked: Boolean,
    title: String,
  },
  computed: {
    color() {
      return this.unlocked ? "#D3A82C" : "#808080";
    },
  },
};
</script>

<style lang="scss" scoped>
.trophy-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 5px;
  cursor: pointer;

  p {
    margin: 5px 0 0 0;
    color: #fff;
    text-align: center;
    flex: 1 0 auto;
    margin-top: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  svg {
    height: auto;
    margin-bottom: 10px;
    flex-shrink: 0;

    &.unlocked {
    }

    &.locked {
      opacity: 0.6;
    }
  }

  .empty {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #000;
  }
}
</style>
